import { Box, Container, Typography } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBg,
  colorBlack,
  textStyle,
  titleStyle,
} from "../../../Resources/Design/theme";

export default function WhatWeDo() {
  return (
    <Box sx={{}}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          position: "relative",
          zIndex: 5,
          flexDirection: { xs: "column", sm: "row" },
          py: { xs: "60px", sm: "90px", md: "90px" },
          pb: { xs: "0px", sm: "60px", md: "60px" },
        }}
        id="aboutus"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", sm: "100%" },
            textAlign: "left",
            mr: { xs: "0px", sm: "24px" },
          }}
        >
          <Typography sx={{ ...titleStyle, color: colorApp }}>
            Co děláme?
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: colorBlack,
              mt: "14px",
              maxWidth: { xs: "100%", sm: "100%" },
            }}
          >
            Děláme co nás baví. Tady bychom mohli skončit, ale to my právě
            nechceme. Proto, když jsme zjistili, že máme rádi kynologii a tvorbu
            kontentu, rozhodli jsme se, že neskončíme jen na jednom bodě, ale že
            to posuneme dál. Rádi bychom naše nadšení pro psy přenesli na
            ostatní lidi v oboru, ať už to jsou profesionální trenéři, lajci,
            noví majitelé psů, nebo třeba jen lidi, které toto téma zajímá.
            Cílem je spojit všechny tyto vrstvy a vytvořit komunitu a posunout
            celou kynologii o krok dál. Máme tedy v plánu tvořit edukativní,
            předváděcí, zábavná a jiná videa na tuto tématiku, která tu budou
            hlavně pro Vás a na kterých, doufáme, se zapojíte s námi - ať už
            jakýmkoliv dotazem, požadavkem rozebrat témata, nebo přímou účastí v
            našem videu se záměrem předat danou hodnotu. Těšíme se na vás!
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
